import * as React from 'react';

import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { buildHashWithAuthMode, getLocationHash } from 'js/lib/authModeDeepLinkUtils';
import requestCountry from 'js/lib/requestCountry';
import user from 'js/lib/user';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';

import 'css!bundles/acclaim/styl/index';

class AcclaimApp extends React.LegacyComponentWithChildren {
  static propTypes = {
    requestCountryCode: PropTypes.string,
    csrfToken: PropTypes.string,
    children: PropTypes.node,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    getStore: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof AcclaimApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  getChildContext() {
    return {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'csrfToken' does not exist on type 'Reado... Remove this comment to see the full error message
      csrfToken: this.props.csrfToken,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'requestCountryCode' does not exist on ty... Remove this comment to see the full error message
      requestCountryCode: this.props.requestCountryCode,
    };
  }

  componentDidMount() {
    if (!user.isAuthenticatedUser()) {
      const { router } = this.context;
      router.replace({
        pathname: router.location.pathname,
        query: omit({ ...router.location.query }, 'authMode'),
        hash: buildHashWithAuthMode(getLocationHash(router.location), 'login'),
      });
    }
  }

  render() {
    const { children } = this.props;

    return (
      <div className="rc-AcclaimApp">
        <DefaultHeader showMetaNav />
        <UniversalPageFeatures />
        {user.isAuthenticatedUser() && children}
      </div>
    );
  }
}

export default connectToStores(AcclaimApp, ['ApplicationStore'], (context, props) => ({
  ...props,
  csrfToken: context.ApplicationStore.getState().csrfToken,
  requestCountryCode: requestCountry.get(),
}));
